'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '2.10.2';


// WEBPACK FOOTER //
// ./~/instantsearch.js/dist-es5-module/src/lib/version.js